import { render, staticRenderFns } from "./MainTrolley.vue?vue&type=template&id=0e530a1c&scoped=true"
import script from "./MainTrolley.vue?vue&type=script&lang=js"
export * from "./MainTrolley.vue?vue&type=script&lang=js"
import style0 from "./MainTrolley.vue?vue&type=style&index=0&id=0e530a1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e530a1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
